
/**
 * Helper to resolve image URLs.
 * Support both full Cloudinary URLs and legacy relative paths.
 */
export const getImageUrl = (path) => {
    if (!path) return "";

    // Convert to string if it's not already (handles image_manager_id numbers)
    const pathString = String(path);

    if (pathString.startsWith("http://") || pathString.startsWith("https://")) {
        return pathString;
    }
    return pathString;
};
